import Vue from 'vue'
import { Lazyload } from 'vant'

const lazyLoadOptions = {}

Vue.use(Lazyload, lazyLoadOptions)
